import * as React from 'react';

import { EMessageType } from '../../types/messageType';
import { ChatMessageBubble } from '../ChatMessageBubble';
import { ChatMessageLayout } from '../ChatMessageLayout';
import { ChatMessageRow } from '../ChatMessageRow';
import { TypingMessage } from '../TypingMessage';

/* istanbul ignore next */
export const ChatMessageChatbotTyping = () => {
  return (
    <ChatMessageLayout messageType={EMessageType.Incoming}>
      <ChatMessageRow>
        <ChatMessageBubble messageType={EMessageType.Incoming} withTail>
          <TypingMessage />
        </ChatMessageBubble>
      </ChatMessageRow>
    </ChatMessageLayout>
  );
};
